<template>
  <div class="w-100 position-relative bg-white hide-scroll" >
  	<top-navbar 
      title="Saved Address" 
      :url="`/${getMerchant.code}/account`"
      right_menu
      :right_menu_data="navbarConfig"
      @right-on-back="toggleForm"
    />
  	<block :height="60" />

    <div class="container" style="min-height: calc(100vh - (60px + 73px) - 24px);">
      <div v-if="listStatus.isLoading" class="w-100 py-4 text-center">
        <loader />
      </div>
      <template v-else>
        <div v-if="listStatus.error" class="py-3">
          <ErrorMessage :message="listStatus.error" />
        </div> 
        <template v-else>
          <div v-for="addressItem in listAddress" class="w-100 rounded bg-white box-shadow-light-aff border-form p-3 mb-4">
            <p class="mb-0 body-1-4 w-100 text-truncate mb-2">{{ addressItem.title }}</p>
            <div class="w-100 pb-3 mb-3 border-b-form-dashed-2">
              <p class="body-3-3 mb-2">{{ addressItem.full_address }}</p>
              <div class="w-100 d-flex align-items-center">
                <svg class="mr-2" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="directions_24px">
                    <path id="icon/maps/directions_24px" fill-rule="evenodd" clip-rule="evenodd"
                      d="M22.4275 10.5931L13.4175 1.58312C12.6675 0.833125 11.3475 0.823125 10.5875 1.58312L1.58746 10.5831C0.807457 11.3631 0.807457 12.6231 1.58746 13.4031L10.5875 22.4031C10.9775 22.7931 11.4875 22.9831 11.9975 22.9831C12.5075 22.9831 13.0175 22.7931 13.4075 22.4031L22.3975 13.4131C23.1875 12.6531 23.1975 11.3931 22.4275 10.5931ZM12.0075 20.9931L3.00746 11.9931L12.0075 2.99312L21.0075 11.9931L12.0075 20.9931ZM7.99746 15.0031V11.0031C7.99746 10.4531 8.44746 10.0031 8.99746 10.0031H13.9975V7.50312L17.4975 11.0031L13.9975 14.5031V12.0031H9.99746V15.0031H7.99746Z"
                      class="fill-primary" />
                  </g>
                </svg>
                <p class="body-3-3-1 mb-0">{{ addressItem.address }}</p>
              </div>
            </div>
            <div class="row slim-grid-row">
              <div class="col-5">
                <state-button
                  :click="deleteAddress" 
                  :data="{addressId: addressItem.id}"
                  size="sm"
                  variant="danger-outline"
                  block >
                  Delete
                </state-button>
              </div>
              <div class="col-7">
                <state-button
                  :click="selectAddress" 
                  :data="addressItem"
                  size="sm"
                  variant="primary"
                  block >
                  Edit
                </state-button>
              </div>
            </div>
          </div>
        </template>
      </template>
      

      <popup-detail
        direction="bottom" 
        :show="showForm"
        use_max_size
        :title="formTitle"
        wrapper_size="mobile"
        :use_footer="showFooterForm"
        :no_close_backdrop="noCloseBackdrop"
        @close="toggleForm">

        <template v-slot:body>
          <SetupAddress 
            v-if="showForm" 
            ref="setupAddress" 
            :default-data="selectedItem"
            @show-footer="toggleFooterForm"
            @no-close-backdrop="toggleNoCloseBackdropForm"
          /> 
        </template>
        
        <template v-slot:footer>
          <div class="p-4 border-t-form">
            <p v-if="pushError != ''" class="mb-2 body-2-4 text-danger w-100 text-center">{{ pushError }}</p>
            <state-button
              :click="submitAddress" 
              size="lg"
              variant="primary"
              block >
              {{ buttonSaveTitle }}
            </state-button>
          </div>
        </template>
      </popup-detail>  
    </div>
    
    <BottomNavbar page="ACCOUNT" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import BottomNavbar from '../../components/restaurant-v2/BottomNavbar.vue';
  import SetupAddress from '../../components/general/SetupAddress.vue';
  import { post, get, remove, put } from "@/services/index.js";

  export default {
    components:{
      BottomNavbar,
      SetupAddress
    },
    data(){
      return{
        navbarConfig:{
          type: 'title',
          title: 'Add New',
          img: '',
          left: 'title',
          url: '/',
          run_function: true 
        },
        showForm: false,
        showFooterForm: false,
        noCloseBackdrop: false,
        selectedItem: {},
        listStatus:{
          isLoading: true,
          error: ""
        },
        listAddress: [],
        pushError: ""
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      formType(){
        return this.$isEmpty(this.selectedItem) ? 'NEW' : 'EDIT'
      },
      formTitle(){
        return this.formType === 'NEW' ? 'Add new address' : 'Edit address'
      },
      buttonSaveTitle(){
        return this.formType === 'NEW' ? 'Save Address' : 'Update Address'
      }
    },
    mounted(){
      this.getListitem()
    },
    methods:{
      toggleForm(){
        this.showForm = !this.showForm;
        if(!this.showForm) this.selectedItem = {}
      },
      toggleFooterForm(show){
        this.showFooterForm = show
      },
      toggleNoCloseBackdropForm(show){
        this.noCloseBackdrop = show
      },
      selectAddress(address){
        this.selectedItem = address
        this.toggleForm();
        return Promise.resolve();
      },
      async getListitem(){
        try {
          this.listStatus.isLoading = true
          
          const apiResponse = await get("CORE_RESTO", "shipping-address");
          const { success, data, message } = apiResponse.data
          if(!success) throw new Error(message);
          
          this.listAddress = await Promise.all(
            data.map(async (item) => {
              item.full_address = await this.getDetailLocation(item.latitude, item.longitude);
              return item;
            })
          );
        } catch (error) {
          this.listStatus.error = error.message
        } finally {
          this.listStatus.isLoading = false
        }
      },
      async getDetailLocation(lat,long){
        try {
          const apiResponse = await get("CORE", "user-location", { lat, long });
          const { success, message, data } =  apiResponse.data

          if(!success) throw new Error(message);
          
          return data.formatted_address;
        } catch (error) {
          throw error;
        }
      },
      async submitAddress(){
        try {
          this.toggleNoCloseBackdropForm(true)
          this.pushError = ''

          const formData = await this.$refs.setupAddress.submitForm();
          if(this.$isEmpty(formData)) {
            this.toggleNoCloseBackdropForm(false)
            return Promise.resolve()
          };
          const apiParams = this.getParamsSubmitAddress(formData);

          const isUpdate = this.$isNotEmptyV2(this.selectedItem);
          if(isUpdate) await this.updateAddress(apiParams)
          else await this.saveAddress(apiParams);
          
          this.toggleForm();
          this.getListitem();
        } catch (error) {
          this.pushError = error.message;
        } finally {
          this.toggleNoCloseBackdropForm(false)
          return Promise.resolve();
        } 
      },
      async saveAddress(apiParams){
        try {
          const apiResponse = await post("CORE_RESTO", "shipping-address", apiParams);
          const { success, data, message } = apiResponse.data
          if(!success) throw new Error(message);
        } catch (error) {
          throw error;
        }
      },
      async updateAddress(apiParams){
        try {
          const apiResponse = await put("CORE_RESTO", `shipping-address/${this.selectedItem.id}`, apiParams);
          const { success, data, message } = apiResponse.data
          if(!success) throw new Error(message);
          this.selectedItem = {}
        } catch (error) {
          throw error;
        }
      },
      getParamsSubmitAddress(formData){
        try {

          const { latitude, longitude, city,  landmark : address, title, receiver_name, phone="-" } = formData;
          
          return {
            latitude, longitude, title, receiver_name, phone, city, address,
            latitude_ori: latitude,
            longitude_ori: longitude,
          }
        } catch (error) {
          throw error;
        }
      },
      async deleteAddress({addressId}){
        try {

          const apiResponse = await remove("CORE_RESTO", `shipping-address/${addressId}`);
          const { success, data, message } = apiResponse.data
          if(!success) throw new Error(message);
          
          this.getListitem();
        } catch (error) {
          console.log("ERROR : deleteAddress ", error.message);
        } finally {
          return Promise.resolve();
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/general/SavedAddress.vue